import React from "react";
import styled, { keyframes } from "styled-components/macro";

const StyledLoader = styled.span`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 1rem;
  box-sizing: border-box;
`;

const DotContainer = styled.div<{ size: number }>`
  display: flex;
  width: ${(props) => props.size * 8}em;
  justify-content: space-evenly;
`;

const pulse = keyframes`
  from {
    transform: scale(0.8)
  }
  50% {
    transform: scale(1.3)
  }
  to {
    transform: scale(0.8)
  }
`;

type DotProps = {
  delay: number;
  size: number;
};

const Dot = styled.div<DotProps>`
  height: ${(props) => props.size}em;
  width: ${(props) => props.size}em;
  background: #5c7284;
  border-radius: 50%;
  animation: 1s linear ${(props) => `${props.delay}s`} ${pulse} infinite;
`;

const Loader = (props: { size?: number }) => (
  <StyledLoader data-testid="Loader">
    <DotContainer size={props.size ?? 1}>
      <Dot size={props.size ?? 1} delay={0} />
      <Dot size={props.size ?? 1} delay={0.25} />
      <Dot size={props.size ?? 1} delay={0.5} />
    </DotContainer>
  </StyledLoader>
);

export default Loader;
